import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Container } from "react-bootstrap";
import { useAlert } from "../../../../context/AlertContext";
import { useLoading } from "../../../../context/LoadingContext";
import {
  addEditServiceRequest,
  getServiceRequest
} from "../../../../commons/ServiceRequest";
import SetMachineTypeForm from "../../../../components/GeneralForm/SetMachineTypeForm";
import McTypeService from "../../../../services/mctype.service";

export default function EditSetMachineType() {
  const navigate = useNavigate();
  const { id } = useParams();
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();
  const [editMCType, setEditMCType] = useState();

  useEffect(() => {
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: McTypeService.getMcTypes(id),
      callback: (res) => setEditMCType(res)
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>แก้ไข MC Type</title>
        <meta name="description" content="Edit Machine Type Page" />
      </Helmet>

      <Container fluid className="p-3">
        <SetMachineTypeForm
          editData={editMCType}
          onSubmitCallback={(data) => {
            delete data?.Item_Id;
            addEditServiceRequest({
              showAlert,
              setLoading,
              serviceRequest: McTypeService.editMcTypes(id, data),
              navigated: (navi) => navi && navigate(0)
            });
          }}
        />
      </Container>
    </>
  );
}
